
























import { Component, Vue } from "vue-property-decorator";
import { AddClientFormCpt } from "./components";
import { WorkshopModel, CompanyModel } from "@/core/models";
import { WorkshopService } from "@/core/services";
import { WorkshopDetailHeaderCpt } from "./components";

@Component({
  components: {
    WorkshopDetailHeaderCpt,
    AddClientFormCpt,
  },
})
export default class WorkshopAddClient extends Vue {
  newCompanyModel = new CompanyModel();

  get workshopId() {
    return Number(this.$route.params.workshopId);
  }

  model = {} as WorkshopModel;
  loading = false;

  async created() {
    this.initializeModel();
  }

  private async initializeModel() {
    this.loading = true;
    try {
      this.model = await WorkshopService.getWorkshop(this.workshopId);
    } finally {
      this.loading = false;
    }
  }
}
